<script setup lang="ts">
import AddOnsContent from './components/AddOnsContent.vue'

definePage({
  path: 'add-ons',
  name: '/onboarding/add-ons',
  meta: {
    layout: 'false',
    allowedRoles: [ 'CustomerOnboarding' ],
  },
})

const onboardingStore = useOnboardingStore()
const { companyModel, hasCreditPackage, wantsCompanyVideo, wantsSocialMediaPostDiscount } = storeToRefs(onboardingStore)

function prevPage() {
  onboardingStore.goToPage(2)
}

if (companyModel.value === undefined) {
  onboardingStore.goToPage(2)
}

function nextPage() {
  onboardingStore.goToPage(4)
}
</script>

<template>
  <AddOnsContent
    v-model:wants-company-video="wantsCompanyVideo"
    v-model:wants-social-media-post-discount="wantsSocialMediaPostDiscount"
    :has-credit-package="hasCreditPackage"
    @prev="prevPage"
    @next="nextPage"
  />
</template>
